import { render, staticRenderFns } from "./Amenities.vue?vue&type=template&id=e9bc89de&scoped=true"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"
import style0 from "./Amenities.vue?vue&type=style&index=0&id=e9bc89de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bc89de",
  null
  
)

export default component.exports